module.exports = __webpack_public_path__ + "static/media/prusa.1940e836.jpg";